import HalfGrid from './half_grid_section'

export default {
  half_grid: HalfGrid,
}
